module.exports = __webpack_public_path__ + "img/selected-drifting-luminescence-2.94b75464.webp";